import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createTrackingReport } from '@/features/projects/kpi-tracking-entry/api/create-tracking-report';
import { invalidateTrackingReportQueries } from '@/features/projects/kpi-tracking-entry/hooks/use-tracking-reports';

type CreateTrackingReportMutationProps = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useCreateTrackingReportMutation = ({
  onSuccess,
  onError,
}: CreateTrackingReportMutationProps = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createTrackingReport,
    onSuccess: (_reportId, variables) => {
      invalidateTrackingReportQueries(queryClient, variables.projectId);
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
};
